import { ChevronRightIcon } from '@heroicons/react/solid';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import React from 'react';

import ButtonDefault, { ButtonVariants } from '../basic/button';
import { ShouldRender } from '../basic/ShouldRender';

interface HeadingProps {
  heading: string;
  subHeading?: string;
  isSmall?: boolean;
  showButton?: boolean;
  route?: string;
}

const Heading: React.FC<HeadingProps> = ({
  heading,
  subHeading,
  isSmall = false,
  showButton = false,
  route,
}) => {
  const screens = useBreakpoint();
  const router = useRouter();
  return (
    <>
      <div className='flex flex-col gap-y-14'>
        <div className='flex justify-between items-center  mb-6 md:mb-10'>
          <div
            className={clsx(
              ' leading-7 text-fadedWhite ',
              isSmall
                ? 'text-2xl font-medium'
                : 'text-base md:text-2xl flex lg:text-3xl font-bold',
            )}
          >
            <span className='flex  whitespace-nowrap'>
              Add {heading}{' '}
              <ShouldRender check={heading === 'Bundles'}>🔥</ShouldRender>{' '}
            </span>
          </div>
          <div className='flex justify-center items-center'>
            <ShouldRender check={!showButton && router.pathname === '/product'}>
              <ButtonDefault
                size={screens.md ? 4 : 0}
                enableScaling={false}
                variant={
                  screens.md ? ButtonVariants.GRAY : ButtonVariants.UNSTYLED
                }
                className='w-full  border-none  md:bg-[#1C1C1C] text-sm text-white font-semibold'
                onClick={() => route && router.push(route)}
              >
                <span className='md:py-1 text-[10px] md:text-sm flex items-center'>
                  Explore All {heading}{' '}
                  <ChevronRightIcon className='w-5 h-5' />{' '}
                </span>
              </ButtonDefault>
            </ShouldRender>
          </div>
        </div>

        <ShouldRender check={subHeading}>
          <div
            className={clsx(
              'flex flex-col leading-loose md:pl-24',
              isSmall ? 'text-fadedWhite' : 'text-fadedWhite',
            )}
          >
            <span className='text-2xl font-medium'>{subHeading}</span>
          </div>
        </ShouldRender>
      </div>
    </>
  );
};

export default Heading;
